/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/reasonCodeOperationModal/reasonCodeOperationContainer" />
import * as React from "react";
import { reasonCodeStrategies } from "./reasonCodeOperationStrategies";
import { useInvoiceReasonCodeData } from "../rejectionManagementWizard/useInvoiceReasonCodeData";
import { ReasonCodeOperationModal } from "./reasonCodeOperationModal";
import { mapFromNorthstarToApa } from "Core/Medius.Core.Web/Scripts/lib/northstarLocalization";
import { getCultureCode } from "Core/Medius.Core.Web/Scripts/Medius/lib/utils/user";
import { LocalizationContext } from "@medius/ui-controls";
import { EntityType, ReasonCodeOperationType } from "../shared/interfaces";
import { IReasonCode } from "../rejectionManagementWizard/interfaces";

export interface ReasonCodeOperationContainerProps {
    show: boolean;
    modalType: ReasonCodeOperationType;
    hierarchyId: string;
    documentId: number;
    taskId: number;
    entityType: EntityType;
    currentDocumentType: string;
    onClose: (confirmed: boolean) => void;
    onReasonsConfirm?: (selectedReason: IReasonCode[]) => void;
    preselectedReasons?: IReasonCode[];
}

export const ReasonCodeOperationContainer = ({
    show,
    modalType,
    hierarchyId,
    documentId,
    taskId,
    entityType,
    currentDocumentType,
    onClose,
    onReasonsConfirm,
    preselectedReasons
}: ReasonCodeOperationContainerProps) => {
    const strategy = reasonCodeStrategies[modalType];
    const reasonCodeData = useInvoiceReasonCodeData(
        modalType,
        hierarchyId,
        strategy.rejectOperation
    );

    const handleSubmit = async (selection: IReasonCode[]) => {
        await strategy.submit({
            documentId,
            selection,
            taskId,
            entityType,
            documentType: currentDocumentType,
            onReasonsConfirm
        });

        onClose(true);
    };

    if (!show) return null;
    return (
        <LocalizationContext.Provider value={{
                translate: (key: string, defaultValue?: string) => mapFromNorthstarToApa(key, defaultValue),
                getLocale: () => getCultureCode()
            }}>
            <ReasonCodeOperationModal
                title={strategy.title}
                submitLabel={strategy.submitLabel}
                searchLabel={strategy.searchLabel}
                reasonCodeData={reasonCodeData}
                onSubmit={handleSubmit}
                onClose={onClose}
                preselectedReasons={preselectedReasons}
                reasonCodeOperationType={modalType}
            />
        </LocalizationContext.Provider>
    );
};